import { memo } from "react";
import { Modal, Box, Button } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 368,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 2,
  borderRadius: '6px',
  outline: 'none'
};

interface InfoModalProps {
  open: boolean;
  handleClose: () => void;
  handleOk?: () => void;
  title?: string;
  inputValue?: string; // Updated type to string since we start with an empty string
  closeText?: string;
  submitText?: string;
  singleBtn?: boolean;
  onInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void; // Handler for input change
}

const AddRowModal: React.FC<InfoModalProps> = ({
  open,
  handleClose,
  handleOk,
  title = "Default Title",
  inputValue = '', // Default to empty string
  closeText,
  submitText,
  onInputChange
}) => {
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-title"
        aria-describedby="modal-description"
      >
        <Box sx={modalStyle} className="modal">
          <div className="modal-header flex justify-content-between align-items-center">
            {title &&
              <h3 className="modal-title">
                {title}
              </h3>
            }
            <button className="close" onClick={handleClose}><CloseIcon /></button>
          </div>
          <div className="modal-body">
            <div className="input-wrap">
              <label htmlFor="input-rows">Enter No. of Rows<span>*</span></label>
              <input
                type="number"
                className="input-rows"
                value={inputValue} // Set the input value from the parent
                onChange={onInputChange} // Handle input change
                min="0" // Prevent negative values

              />
            </div>
          </div>
          <div className="modal-footer flex justify-content-center align-items-center">
            {closeText && <Button onClick={handleClose} className="border-btn">{closeText}</Button>}
            {submitText && <Button disabled={!Number(inputValue)} className="primary-btn" onClick={handleOk}>{submitText}</Button>}
          </div>
        </Box>
      </Modal>
    </div>
  );
}

export default memo(AddRowModal);
